import { render, staticRenderFns } from "./eidt-allowed.vue?vue&type=template&id=ef4c3c32&"
import script from "./eidt-allowed.vue?vue&type=script&lang=ts&"
export * from "./eidt-allowed.vue?vue&type=script&lang=ts&"
import style0 from "./eidt-allowed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports